import React from "react";
import "../../styles/Faq.css";

const FAQCollapse = () => {
  const faqItems = [
    {
      question: "Apa itu Originality?",
      answer:
        "Originality adalah perusahaan fashion manufacture yang berbasis di Pati, Jawa Tengah, yang melayani produksi berbagai jenis pakaian dengan fokus pada kualitas, ketepatan waktu, dan desain yang orisinal sesuai kebutuhan brand Anda.",
    },
    {
      question: "Produk apa saja yang bisa diproduksi oleh Originality?",
      answer:
        "Kami melayani produksi berbagai jenis fashion, seperti: T-Shirt, Polo Shirt, Jersey, Raglan, Training, Sweater/Crewneck, Hoodie/Jacket, Kemeja, Lanyard, Totebag, dan Topi.",
    },
    {
      question: "Apakah Originality melayani produksi custom?",
      answer:
        "Ya. Originality melayani produksi custom 100%, mulai dari desain, pemilihan bahan, ukuran, warna, hingga teknik sablon atau bordir sesuai permintaan Anda.",
    },
    {
      question: "Berapa minimum order (MOQ) di Originality?",
      answer:
        "Minimum order tergantung pada jenis produk dan tingkat kesulitannya. Silakan hubungi tim kami untuk mendapatkan informasi MOQ yang paling sesuai dengan kebutuhan Anda.",
    },
    {
      question: "Apakah Originality menerima brand baru atau UMKM?",
      answer:
        "Tentu. Kami terbuka untuk brand baru, UMKM, maupun brand besar dan siap menjadi partner produksi yang terpercaya untuk mengembangkan bisnis fashion Anda.",
    },
    {
      question: "Bahan apa saja yang tersedia?",
      answer:
        "Kami menyediakan berbagai pilihan bahan berkualitas, seperti: Cotton Combed, Cotton Carded, CVC, Baby Terry, Drill, Polyester, Blended, dan bahan khusus lainnya sesuai kebutuhan produksi Anda. Pemilihan bahan bisa disesuaikan dengan kebutuhan produk dan budget.",
    },
    {
      question: "Teknik sablon dan bordir apa yang digunakan?",
      answer:
        "Kami menyediakan berbagai teknik, antara lain: Sablon Plastisol, Sablon Rubber, Sablon Discharge, Sablon Pigmen, Sablon Foil, Bordir Komputer, dan teknik lainnya sesuai kebutuhan desain Anda. Tim kami akan merekomendasikan teknik terbaik sesuai jenis bahan dan desain",
    },
    {
      question: "Berapa lama waktu produksi?",
      answer:
        "Waktu produksi bervariasi tergantung jumlah pesanan dan tingkat kesulitan, umumnya berkisar antara 2–4 minggu setelah desain dan sampel disetujui.",
    },
    {
      question: "Apakah bisa membuat sampel terlebih dahulu?",
      answer:
        "Ya. Kami menyediakan layanan pembuatan sampel agar klien dapat memastikan kualitas, ukuran, dan hasil akhir sebelum masuk ke produksi massal.",
    },
    {
      question: "Apakah Originality menerima pengiriman ke seluruh Indonesia?",
      answer:
        "Ya. Kami melayani pengiriman ke seluruh Indonesia menggunakan jasa ekspedisi terpercaya.",
    },
    {
      question: "Apa itu Our Brands?",
      answer:
        "Our Brands adalah rangkaian merek atau lini produk yang dihasilkan dan/atau dikelola oleh Originality untuk menunjukkan kapasitas produksi, kualitas, dan desain kami. Bagian ini memamerkan contoh produk, kolaborasi, dan case study produksi kami.",
    },
    {
      question:
        "Bagaimana cara bergabung menjadi brand atau mitra di Our Brands?",
      answer:
        "Silakan menghubungi tim kami untuk konsultasi awal. Kami akan menilai kebutuhan produksi, desain, dan strategi branding Anda, lalu menyusun proposal kerja sama yang mencakup sampel, MOQ, dan timeline.",
    },
    {
      question:
        "Apakah Originality menyediakan layanan private label atau OEM?",
      answer:
        "Ya. Kami menyediakan layanan private label/OEM termasuk pembuatan label, hangtag, kemasan, dan personalisasi desain sesuai identitas brand Anda.",
    },
    {
      question: "Berapa MOQ untuk produk di Our Brands atau private label?",
      answer:
        "MOQ bervariasi berdasarkan jenis produk, bahan, dan teknik produksi. Untuk beberapa produk ready-stock MOQ bisa lebih kecil; untuk produksi custom biasanya MOQ lebih tinggi. Hubungi tim kami untuk estimasi yang akurat.",
    },
    {
      question:
        "Apakah Originality membantu pemasaran atau penjualan untuk Our Brands?",
      answer:
        "Kami fokus pada produksi dan pengembangan produk. Untuk pemasaran, kami dapat membantu materi pendukung seperti foto produk, kemasan, dan rekomendasi pemasaran, serta menghubungkan Anda dengan mitra yang relevan jika memungkinkan.",
    },
    {
      question: "Bagaimana cara memesan di Originality?",
      answer:
        "Anda dapat menghubungi kami melalui:  WhatsApp : 081 272 800 800, Email : originalitycloth2016@gmail.com, dan IG / Tiktok : originality2016. Tim kami akan membantu Anda dari proses konsultasi, desain, hingga produksi.",
    },
  ];

  return (
    <section id="faq" className="faq-section">
      <div className="container faq-container">
        <h2 className="faq-title">Frequently Asked Questions (FAQ)</h2>
        <div className="accordion" id="faqAccordion">
          {faqItems.map((item, index) => (
            <div className="accordion-item" key={index}>
              <h2 className="accordion-header" id={`heading${index}`}>
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#collapse${index}`}
                  aria-expanded="false"
                  aria-controls={`collapse${index}`}
                >
                  {item.question}
                </button>
              </h2>
              <div
                id={`collapse${index}`}
                className="accordion-collapse collapse"
                aria-labelledby={`heading${index}`}
                data-bs-parent="#faqAccordion"
              >
                <div className="accordion-body answer">{item.answer}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQCollapse;
